import React from 'react'
import { FaCheck } from "react-icons/fa";
import Diamond from '../images/dimond.png'
import Gold from '../images/gold.png'
import platinum from '../images/platinum.png'
import Silver from '../images/silver.png'
import Bronze from '../images/bronze.png'

function Sponsors() {
  return (
    <div className="container my-5">

        <figure class="text-center">
        <blockquote class="blockquote">
            <h1 className="card-title text-center text-danger"><strong>Sponsorship Packages</strong></h1>
        </blockquote>
        <figcaption class="blockquote-footer">
            <h5>Partner with us to reach industry leaders, researchers, and innovators in technology and engineering management</h5>
        </figcaption>
        </figure>


        <div className="row row-cols-1 row-cols-md-3 g-4 my-5">

        <div className="col">
        <div className="card h-100">
            <div
            className="d-flex justify-content-center align-items-center"
            style={{
                height: "120px",
                backgroundColor: "#00749b", // Blue background
            }}
            >
            <img
                src={Diamond}
                alt="icon"
                width="50"
                height="50"
            />
            <div className="ms-3 text-white">
                <h2 className="card-text mb-0">Diamond</h2>
                <h2 className="card-text mb-0">&#8377; 2.5 lakhs</h2>
            </div>
            </div>
            <div className="card-body">
            <ul className="list-unstyled">
                <li><FaCheck className="text-success me-2" /> 2 spaces (5x5 sqm) exhibition area</li>
                <li><FaCheck className="text-success me-2" /> Dimond sponsor on stage backdrop</li>
                <li><FaCheck className="text-success me-2" /> Featured on all promotional materials</li>
                <li><FaCheck className="text-success me-2" /> 30 minutes presentation time</li>
                <li><FaCheck className="text-success me-2" /> Networking access</li>
                <li><FaCheck className="text-success me-2" /> Conference proceedings included</li>
            </ul>
            {/* <div className="d-flex justify-content-center">
                <button
                    type="button"
                    className="btn btn-outline-primary text-white"
                    style={{ backgroundColor: "#00749b" }}
                >
                  <strong>Download Our Brochure</strong>
                </button>
            </div> */}
            </div>
        </div>
        </div>


        <div className="col">
        <div className="card h-100">
            <div
            className="d-flex justify-content-center align-items-center"
            style={{
                height: "120px",
                backgroundColor: "#c1c13e", // Blue background
            }}
            >
            <img
                src={Gold}
                alt="icon"
                width="50"
                height="50"
            />
            <div className="ms-3 text-white">
                <h2 className="card-text mb-0">Gold</h2>
                <h2 className="card-text mb-0">&#8377; 1.5 lakhs</h2>
            </div>
            </div>
            <div className="card-body">
            <ul className="list-unstyled">
                <li><FaCheck className="text-success me-2" /> 2 spaces (3x3 sqm) exhibition area</li>
                <li><FaCheck className="text-success me-2" /> Gold sponsor on stage backdrop</li>
                <li><FaCheck className="text-success me-2" /> Featured on all promotional materials</li>
                <li><FaCheck className="text-success me-2" /> 20 minutes presentation time </li>
                <li><FaCheck className="text-success me-2" /> Standard networking access </li>
                <li><FaCheck className="text-success me-2" /> Conference proceedings included</li>
            </ul>
            {/* <div className="d-flex justify-content-center">
                <button
                    type="button"
                    className="btn btn-outline-primary text-white"
                    style={{ backgroundColor: "#c1c13e" }}
                >
                  <strong>Download Our Brochure</strong>
                </button>
            </div> */}
            </div>
        </div>
        </div>

        <div className="col">
        <div className="card h-100">
            <div
            className="d-flex justify-content-center align-items-center"
            style={{
                height: "120px",
                backgroundColor: "#5f3903ee", // Blue background
            }}
            >
            <img
                src={platinum}
                alt="icon"
                width="50"
                height="50"
            />
            <div className="ms-3 text-white">
                <h2 className="card-text mb-0">Platinum</h2>
                <h2 className="card-text mb-0">&#8377; 1 lakhs</h2>
            </div>
            </div>
            <div className="card-body">
            <ul className="list-unstyled">
                <li><FaCheck className="text-success me-2" /> 1 space (3x3 sqm) exhibition area</li>
                <li><FaCheck className="text-success me-2" /> Platinum sponsor on stage backdrop </li>
                <li><FaCheck className="text-success me-2" /> Featured on all promotional materials</li>
                <li><FaCheck className="text-success me-2" /> 10 minutes presentation time</li>
                <li><FaCheck className="text-success me-2" /> Networking access</li>
                <li><FaCheck className="text-success me-2" /> Conference proceedings included</li>
            </ul>
            {/* <div className="d-flex justify-content-center">
                <button
                    type="button"
                    className="btn btn-outline-primary text-white"
                    style={{ backgroundColor: "#5f3903ee" }}
                >
                  <strong>Download Our Brochure</strong>
                </button>
            </div> */}
            </div>
        </div>
        </div>

        <div className="col">
        <div className="card h-100">
            <div
            className="d-flex justify-content-center align-items-center"
            style={{
                height: "120px",
                backgroundColor: "#69797e", // Blue background
            }}
            >
            <img
                src={Silver}
                alt="icon"
                width="50"
                height="50"
            />
            <div className="ms-3 text-white">
                <h2 className="card-text mb-0">Silver</h2>
                <h2 className="card-text mb-0">&#8377; 70K</h2>
            </div>
            </div>
            <div className="card-body">
            <ul className="list-unstyled">
                <li><FaCheck className="text-success me-2" /> 1 space (2x2 sqm) exhibition area</li>
                <li><FaCheck className="text-success me-2" /> Silver sponsor on stage backdrop</li>
                <li><FaCheck className="text-success me-2" /> Featured on all promotional materials</li>
                <li><FaCheck className="text-success me-2" /> 5 minutes presentation time</li>
                <li><FaCheck className="text-success me-2" /> Networking access</li>
                <li><FaCheck className="text-success me-2" /> Conference proceedings included</li>
            </ul>
            {/* <div className="d-flex justify-content-center">
                <button
                    type="button"
                    className="btn btn-outline-primary text-white"
                    style={{ backgroundColor: "#69797e" }}
                >
                  <strong>Download Our Brochure</strong>
                </button>
            </div> */}
            </div>
        </div>
        </div>

        <div className="col">
        <div className="card h-100">
            <div
            className="d-flex justify-content-center align-items-center"
            style={{
                height: "120px",
                backgroundColor: "#382101", // Blue background
            }}
            >
            <img
                src={Bronze}
                alt="icon"
                width="50"
                height="50"
            />
            <div className="ms-3 text-white">
                <h2 className="card-text mb-0">Bronze</h2>
                <h2 className="card-text mb-0">&#8377; 50K</h2>
            </div>
            </div>
            <div className="card-body">
            <ul className="list-unstyled">
                <li><FaCheck className="text-success me-2" /> 1 space (2x2 sqm) exhibition area</li>
                <li><FaCheck className="text-success me-2" /> Bronze sponsor on stage backdrop </li>
                <li><FaCheck className="text-success me-2" /> Featured on all promotional materials</li>
                <li><FaCheck className="text-success me-2" /> 2 minutes presentation time</li>
                <li><FaCheck className="text-success me-2" /> Networking access</li>
                <li><FaCheck className="text-success me-2" /> Conference proceedings included</li>
            </ul>
            {/* <div className="d-flex justify-content-center">
                <button
                    type="button"
                    className="btn btn-outline-primary text-white"
                    style={{ backgroundColor: "#382101" }}
                >
                  <strong>Download Our Brochure</strong>
                </button>
            </div> */}
            </div>
        </div>
        </div>

        </div>
    </div>
  )
}

export default Sponsors